import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import DepartmentsItemMenu from '@/views/pages/Departments/elements/DepartmentsItemMenu';

const DepartmentsItem = ({ data, onEditItem, onDeleteItem, setShowModalDeleteItem, setShowModalAddDepartment, setShowModalHeaderFooter }) => {
	const { dict } = useSelector((state) => state.app);

	return (
		<div className='table__departments__item'>
			<div className='table__departments__item--col col-flex'>
				<div className='table__departments__item--col-label'>{dict.departments.list.name}:&nbsp;</div>
				{data.name}
			</div>

			<div className='table__departments__item--col col-flex'>
				<div className='table__departments__item--col-label'>{dict.departments.list.header}:&nbsp;</div>
				{data.headerCustomized ? dict.departments.custom : dict.departments.default}
			</div>
			<div className='table__departments__item--col col-flex'>
				<div className='table__departments__item--col-label'>{dict.departments.list.footer}:&nbsp;</div>
				{data.footerCustomized ? dict.departments.customFooter : dict.departments.defaultFooter}
			</div>
			
			<div
				className='table__departments__item--col col-flex'
				style={ { overflow: 'unset' } }
			>
				<DepartmentsItemMenu
					onEditItem={ onEditItem }
					onDeleteItem={ onDeleteItem }
					setShowModalDeleteItem={ setShowModalDeleteItem }
					setShowModalAddDepartment={ setShowModalAddDepartment }
					setShowModalHeaderFooter={ setShowModalHeaderFooter }
					data={ data }
				/>
			</div>
		</div>
	);
};

export default memo(DepartmentsItem);